import { FlexProps, Flex } from '@chakra-ui/react'
import { MotionProps, Variants } from 'framer-motion'
import React from 'react'
import MotionFlex from '../../utils/MotionFlex'

export type CardProps = FlexProps &
  MotionProps & {
    shouldAnimate?: boolean
  }

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ children, shouldAnimate, ...rest }, ref) => {
    const variants: Variants = {
      show: {
        y: 0,
        opacity: 1
      },
      hide: {
        y: 50,
        opacity: 0
      }
    }

    return (
      <>
        {shouldAnimate ? (
          <MotionFlex animate="show" ref={ref} initial="hide" variants={variants} {...rest}>
            {children}
          </MotionFlex>
        ) : (
          <Flex ref={ref} {...rest}>
            {children}
          </Flex>
        )}
      </>
    )
  }
)

Card.defaultProps = {
  bg: 'white',
  width: 'auto',
  rounded: '0',
  border: 'none',
  onClick: () => false,
  flexDirection: 'column',
  shouldAnimate: false,
  transition: 'all 0.2s ease' as any,
  _hover: {
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
  }
}

export default Card
